import firebase, { analytics } from "firebase";
import Cookies from "js-cookie";

function checkAndSaveUserData(uid, profileData) {
  return new Promise((resolve, reject) => {
    try {
      firebase
        .database()
        .ref(`users/${uid}`)
        .once(
          "value",
          snapshot => {
            var userData = snapshot.val();
            if (userData && userData.creationStatus == "success") {
              reject({
                code: "UserAlreadyExists",
                message: "User already exists, please SignIn to continue"
              });
            } else if (userData && userData.creationStatus != "success") {
              profileData.creationStatus = "success";
              if (Cookies.get("refferalId") && !userData.refferredFromId) {
                profileData.refferredFromId = Cookies.get("refferalId");
              }
              firebase
                .database()
                .ref(`users/${uid}`)
                .update(profileData)
                .then(() => {
                  resolve();
                })
                .catch(err => {
                  reject(err);
                });
            } else {
              // userData.creationStatus == "success";
              console.log("User Data", userData)
              if (Cookies.get("refferalId") && !userData.refferredFromId) {
                profileData.refferredFromId = Cookies.get("refferalId");
              }
              firebase
                .database()
                .ref(`users/${uid}`)
                .set(profileData)
                .then(() => {
                  resolve();
                })
                .catch(err => {
                  reject(err);
                });
            }
          },
          err => {
            console.log("err occured", err);
            reject(err);
          }
        );
    } catch (err) {
      console.log("err occured", err);
      reject(err);
    }
  });
}

function firebaseLogout(router, type) {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        if (!window.location.href.includes("login")) {
          router.replace({
            name: type == "admin" ? "AdminLogin" : "Login"
          });
          resolve();
        } else {
          resolve();
        }
      })
      .catch(err => {
        console.log("err occured", err);
        reject(err);
      });
  });
}

export default {
  signUpWithEmailAndPassword(email, password, profileData, phoneNumber) {
    return new Promise((resolve, reject) => {
      var user;
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(function(res) {
          user = res.user;
          profileData.uid = user.uid;
          profileData.email = user.email;
          profileData.provider = "Email";
          if (Cookies.get("refferalId")) {
            profileData.refferredFromId = Cookies.get("refferalId");
          }
          return firebase
            .database()
            .ref(`users/${user.uid}`)
            .update(profileData);
        })
        .then(() => {
          resolve(user);
        })
        .catch(error => {
          console.log("err occured", error);
          var errorCode = error.code;
          var errorMessage;
          if (errorCode === "auth/email-already-in-use") {
            errorMessage = "Account already exists";
          } else if (errorCode === "auth/invalid-email") {
            errorMessage = "Please enter valid Email address";
          } else if (errorCode === "auth/operation-not-allowed") {
            errorMessage =
              "Failed to Signup, contact Administrator to resolve the issue";
          } else if (errorCode === "auth/weak-password") {
            errorMessage = "Weak Password, Please enter strong password";
          } else {
            errorMessage = "Failed to SignUp the user";
          }
          reject(errorMessage);
        });
    });
  },
  signUpWithGoogle() {
    return new Promise((resolve, reject) => {
      var provider = new firebase.auth.GoogleAuthProvider();
      var user;
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          // The signed-in user info.
          user = result.user;
          // ...
          let firebaseSaveData = {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            provider: "Google"
          };
          user.photoURL ? (firebaseSaveData.photoURL = user.photoURL) : null;
          return checkAndSaveUserData(user.uid, firebaseSaveData);
        })
        .then(() => {
          resolve(user);
        })
        .catch(function(error) {
          console.log("error occured", error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
          reject(error);
        });
    });
  },

  signUpWithFacebook() {
    return new Promise((resolve, reject) => {
      var provider = new firebase.auth.FacebookAuthProvider();
      provider.setCustomParameters({
        display: "popup"
      });
      var user;
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          var token = result.credential.accessToken;
          // The signed-in user info.
          user = result.user;
          // ...
          let firebaseSaveData = {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            provider: "Facebook"
          };
          user.photoURL ? (firebaseSaveData.photoURL = user.photoURL) : null;
          return checkAndSaveUserData(user.uid, firebaseSaveData);
        })
        .then(() => {
          resolve(user);
        })
        .catch(function(error) {
          console.log("error", error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
          reject(error);
        });
    });
  },
  signUpWithApple() {
    return new Promise((resolve, reject) => {
      var provider = new firebase.auth.OAuthProvider("apple.com");
      provider.addScope("email");
      provider.addScope("name");

      var user;
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          var token = result.credential.accessToken;
          // The signed-in user info.
          user = result.user;
          // ...
          let firebaseSaveData = {
            uid: user.uid,
            email: user.email,
            displayName:
              user.displayName || firebase.auth().currentUser.displayName,
            provider: "Apple"
          };
          user.photoURL ? (firebaseSaveData.photoURL = user.photoURL) : null;
          return checkAndSaveUserData(user.uid, firebaseSaveData);
        })
        .then(() => {
          resolve(user);
        })
        .catch(function(error) {
          console.log("error", error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
          reject(error);
        });
    });
  },
  loginWithEmailAndPassword(email, password) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(user => {
          resolve(user);
        })
        .catch(error => {
          console.log("err occured", error);
          var errorMessage;
          var errorCode = error.code;
          if (errorCode === "auth/user-disabled") {
            errorMessage =
              "User has been disabled, contact Administrator for assistance.";
          } else if (errorCode === "auth/invalid-email") {
            errorMessage = "Please enter valid Email address";
          } else if (errorCode === "auth/operation-not-allowed") {
            errorMessage =
              "Failed to Signup, contact Administrator to resolve the issue";
          } else if (errorCode === "auth/user-not-found") {
            errorMessage =
              "No User Found, please check if you Signed Up from different authentication providers.";
          } else if (errorCode === "auth/wrong-password") {
            errorMessage = "Enter the Valid Email & password";
          } else {
            errorMessage = "Failed to SignIn the user";
          }
          reject(errorMessage);
        });
    });
  },
  loginWithGoogle() {
    return new Promise((resolve, reject) => {
      var provider = new firebase.auth.GoogleAuthProvider();
      var user;
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          // The signed-in user info.
          user = result.user;
          // ...
          firebase
            .database()
            .ref(`users/${user.uid}`)
            .once("value", snapshot => {
              var userData = snapshot.val();
              if (
                !userData ||
                (userData && userData.creationStatus != "success")
              ) {
                reject({
                  code: "UserDoesntExist",
                  message: "No user found, Please signup to continue"
                });
              } else {
                resolve(user);
              }
            });
        })
        .catch(function(error) {
          console.log("error occured", error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
          reject(error);
        });
    });
  },
  loginWithFacebook() {
    return new Promise((resolve, reject) => {
      var provider = new firebase.auth.FacebookAuthProvider();
      provider.setCustomParameters({
        display: "popup"
      });
      var user;
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          var token = result.credential.accessToken;
          // The signed-in user info.
          user = result.user;
          // ...
          firebase
            .database()
            .ref(`users/${user.uid}`)
            .once("value", snapshot => {
              var userData = snapshot.val();
              if (
                !userData ||
                (userData && userData.creationStatus != "success")
              ) {
                reject({
                  code: "UserDoesntExist",
                  message: "No user found, Please signup to continue"
                });
              } else {
                resolve(user);
              }
            });
        })
        .catch(function(error) {
          console.log("error", error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
          reject(error);
        });
    });
  },
  loginWithApple() {
    return new Promise((resolve, reject) => {
      var provider = new firebase.auth.OAuthProvider("apple.com");
      provider.addScope("email");
      provider.addScope("name");

      var user;
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a Apple Access Token. You can use it to access the Apple API.
          var token = result.credential.accessToken;
          // The signed-in user info.
          user = result.user;
          // ...
          firebase
            .database()
            .ref(`users/${user.uid}`)
            .once("value", snapshot => {
              var userData = snapshot.val();
              if (
                !userData ||
                (userData && userData.creationStatus != "success")
              ) {
                reject({
                  code: "UserDoesntExist",
                  message: "No user found, Please signup to continue"
                });
              } else {
                resolve(user);
              }
            });
        })
        .catch(function(error) {
          console.log("error", error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
          reject(error);
        });
    });
  },
  signOut(router, type) {
    return firebaseLogout(router, type);
  },
  adminLogin(email, password) {
    return new Promise((resolve, reject) => {
      try {
        let user;
        firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then(res => {
            user = res.user;
            return res.user.getIdTokenResult();
          })
          .then(token => {
            if (token.claims.admin === true) {
              resolve(user);
            } else {
              firebase
                .auth()
                .signOut()
                .then(() => {
                  reject("Enter valid username & password");
                });
            }
          })
          .catch(error => {
            var errorMessage;
            var errorCode = error.code;
            if (errorCode === "auth/user-disabled") {
              errorMessage =
                "User has been disabled, contact Administrator for assistance.";
            } else if (errorCode === "auth/invalid-email") {
              errorMessage = "Please enter valid Email address";
            } else if (errorCode === "auth/operation-not-allowed") {
              errorMessage =
                "Failed to Signup, contact Administrator to resolve the issue";
            } else if (errorCode === "auth/user-not-found") {
              errorMessage =
                "No User Found, please check if you Signed Up from different authentication providers.";
            } else if (errorCode === "auth/wrong-password") {
              errorMessage = "Enter the Valid Email & password";
            } else {
              errorMessage = "Failed to SignIn the user";
            }
            reject(errorMessage);
          });
      } catch (err) {
        reject(err);
      }
    });
  },
  getUserDetails(uid) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(`users/${uid}`)
        .once("value")
        .then(snapshot => {
          resolve(snapshot.val());
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getSubscriptionDetails(uid) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("subscriptions")
        .child(uid)
        .once("value")
        .then(snapshot => {
          resolve(snapshot.val() || null);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateUserData(uid, userData) {
    return firebase
      .database()
      .ref("users")
      .child(uid)
      .update(userData);
  }
};
